// SubCategoryDetailPage.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import productAll from "../../api/productAll";
import categoryData from "../../api/categories";
import { formatPage } from "../../utils/formatPage";
import { useCurrency } from "./../../components/PriceFormat/PriceFormat";
const SubCategoryDetailPage = () => {
  const { categoryName, subcategoryName } = useParams();
  const [products, setProducts] = useState([]);
  //price
  const { currency, conversionRate } = useCurrency();

  const category = categoryData.category.find(
    (cat) => formatPage(cat.categoryname) === formatPage(categoryName)
  );

  const subCategory = category?.subcategories.find(
    (sub) => formatPage(sub.name) === formatPage(subcategoryName)
  );

  useEffect(() => {
    productAll().then(setProducts);
  }, []);

  const filteredProducts = products.filter((product) =>
    product.category?.some(
      (cat) => formatPage(cat) === formatPage(subcategoryName)
    )
  );

  if (!subCategory) {
    return (
      <>
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-6 text-center">
              <div className="alert alert-warning" role="alert">
                An error occurred, please try again later!
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="container-fluid">
      <div className="my-5">
        <h4 className="text-center fw-light mb-0">{subCategory.name}</h4>
        <p className="text-center fw-light">{category?.categoryname}</p>
      </div>

      <div className="row">
        {filteredProducts.length === 0 ? (
          <div className="col-12 text-center">
            <span className="badge bg-secondary text-white fw-light">
              No products found in this category!
            </span>
          </div>
        ) : (
          filteredProducts.map((product) => (
            <div
              key={product.id}
              className="col-lg-3 col-md-4 col-sm-6 col-12 pe-0 px-0"
            >
              <a
                href={`/product/${product.id}`}
                className="text-decoration-none text-dark"
              >
                <img
                  src={product.default_images[0]}
                  alt={product.name}
                  className="w-100"
                />
                <div className="px-3 bg-light pt-2 mb-0">
                  <h5 className="mb-1">{product.name}</h5>
                  {product.availability.toLowerCase() === "in stock" ? (
                    <p className="homeproducttitle  text-muted  mt-1 mb-0 pb-2">
                      {(product.price / conversionRate)
                        .toFixed(3)
                        .replace(/^0\.0*/, "")}
                      <span className="mx-1">{currency}</span>
                    </p>
                  ) : (
                    <p className="homeproducttitle  fw-bold  mt-1 text-danger pb-2 mb-0">
                      Out of Stock!
                    </p>
                  )}
                </div>
              </a>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SubCategoryDetailPage;
